export default {
  type: "templates-mails",
  subject: null,
  title: null,
  from: null,
  recipients: null,
  cc: null,
  bcc: null,
  content: "",
  relationshipNames: ["organization", "typesMail"],
  organization: {
    type: "organizations",
    id: null,
  },
  typesMail: {
    type: "types-mails",
    id: null,
  },
};
